export const formattedPrice = (config, price) => {
  if (!price) {
    return "";
  }

  if (!config) {
    return price;
  }

  const configObj = JSON.parse(config);

  return Intl.NumberFormat(configObj.locale ? configObj.locale : "en-US", {
    style: "currency",
    currency: configObj.currency,
    currencyDisplay: "symbol",
    maximumFractionDigits: 2,
  }).format(price);
};
